module.exports = __webpack_public_path__ + "img/ag.231f9400.svg";